import { Modal } from "@circleco/compass/components/Modal";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

const I18N_ROOT = "event_delete_modal.paid_attendees_blocking";
const EVENT_NAME_PLACEHOLDER = "{eventName}";

interface RemoveAttendeesFirstModalProps {
  attendeeCount: number;
  eventName: string;
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onGoToAttendees: () => void;
}

export const RemoveAttendeesFirstModal = ({
  attendeeCount,
  eventName,
  isLoading = false,
  isOpen,
  onClose,
  onGoToAttendees,
}: RemoveAttendeesFirstModalProps) => {
  const [beforeEventName, afterEventName] = t([I18N_ROOT, "description"], {
    count: attendeeCount,
    event_name: EVENT_NAME_PLACEHOLDER,
  }).split(EVENT_NAME_PLACEHOLDER);

  return (
    <Modal.Root
      open={isOpen}
      onOpenChange={open => {
        if (!open && !isLoading) onClose();
      }}
      size="sm"
    >
      <Modal.Content>
        <Modal.Header title={t([I18N_ROOT, "title"])} />
        <Modal.Body>
          <Typography variant="body-sm">
            {beforeEventName}
            <strong>{eventName}</strong>
            {afterEventName}
          </Typography>
        </Modal.Body>
        <Modal.Footer
          primaryAction={{
            label: t([I18N_ROOT, "go_to_attendees"]),
            onClick: onGoToAttendees,
            loading: isLoading,
            disabled: isLoading,
            shouldCloseModal: false,
          }}
          secondaryAction={{
            label: t([I18N_ROOT, "cancel"]),
            onClick: () => {
              if (!isLoading) onClose();
            },
            shouldCloseModal: false,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
